import React from "react";
import { useNavigate } from "react-router-dom";

const prelimsTopics = [
  { title: "Indian Polity and Governance", path: "/prelims-polity" },
  { title: "Geography (India and World)", path: "/prelims-geography" },
  { title: "Economic and Social Development", path: "/prelims-economy" },
  { title: "Environment and Ecology", path: "/prelims-environment" },
  { title: "General Science and Technology", path: "/prelims-science" },
  { title: "Current Affairs (Highly Important)", path: "/prelims-current-affairs" }
];

const csatTopics = [
  { title: "Reading Comprehension", path: "/csat-reading" },
  { title: "Logical Reasoning", path: "/csat-reasoning" },
  { title: "Analytical Ability", path: "/csat-analytical" },
  { title: "Basic Numeracy (Class 10 level)", path: "/csat-numeracy" }
];

const Prelims = () => {
  const navigate = useNavigate();

  return (
    <div className="container mt-5">

      <div className="text-center mb-4">
        <h2 className="fw-bold">📘 UPSC Prelims</h2>
        <p>Complete Preparation Structure</p>
      </div>

      {/* GS PAPER */}
      <h4 className="fw-bold mb-3">📌 Detailed Syllabus – GS Paper I</h4>

      <div className="row g-4 mb-5">
        {prelimsTopics.map((item, index) => (
          <div key={index} className="col-12 col-md-6 col-lg-4">

            <div
              onClick={() => navigate(item.path)}
              style={{
                background: "#0f172a",
                padding: "20px",
                borderRadius: "12px",
                color: "#fff",
                cursor: "pointer",
                transition: "0.3s"
              }}
              onMouseEnter={(e) =>
                e.currentTarget.style.transform = "scale(1.05)"
              }
              onMouseLeave={(e) =>
                e.currentTarget.style.transform = "scale(1)"
              }
            >
              <h6>{index + 1}. {item.title}</h6>
            </div>

          </div>
        ))}
      </div>

      {/* CSAT */}
      <h4 className="fw-bold mb-3">📊 CSAT Paper (Qualifying)</h4>

      <div className="row g-4">
        {csatTopics.map((item, index) => (
          <div key={index} className="col-6 col-md-3">

            <div
              onClick={() => navigate(item.path)}
              style={{
                background: "#1e293b",
                padding: "20px",
                borderRadius: "12px",
                color: "#fff",
                textAlign: "center",
                cursor: "pointer"
              }}
            >
              <h6>{item.title}</h6>
            </div>

          </div>
        ))}
      </div>
<br></br>
<br></br>
    </div>
  );
};

export default Prelims;